// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const { OKLink } = require('commonsComponents/OKLink');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
 
// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const infoIcon = require('assets/images/icon-info-blue.svg');
const ErrorStep = require ('./modifyEcommerceErrorStep');
const SuccessStep = require('./modifyEcommerceSuccessStep');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const ModifyEcommerceKeyStep1 = require('./modifyEcommerceKeyStep1');
require('./myProfileEcommerceKeyModifyView.scss');

// @constants
const { ECOMMERCE_MODIFY_ID } = require('constants/operationTypes');
const { CHALLENGE_PAGE } = require("constants/biocatch");

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

// @actions
const modifyEcommerceKey = require('actions/modifyEcommerceKey');

class MyProfileEcommerceKeyModifyView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        const { resetModifyEcommerceKey } = this.props;
        resetModifyEcommerceKey();
    }

    onHandleConfirmButton = () => {
        const { confirmModifyEcommerceKey } = this.props;
        changeBiocatchContext(CHALLENGE_PAGE);
        confirmModifyEcommerceKey();
    } 

    setEcommerceKey = (newEcommerceKey) => {
        const { setEcommerceKeyField } = this.props;
        setEcommerceKeyField(newEcommerceKey);
    }
    
    isReady() {
        return false;
    }

    buildContent() {
        const { immProfile, immEcommerceKeyModify, sendNewEcommerceKey } = this.props;
        let block;
        const linkToEcommerceLanding = `/myprofile/keys/ecommerce`;

        const boxBody = (
            <React.Fragment>
                <div className="keys-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <FormattedText
                    className="contact-info-box__list-item-value"
                    value="eCommerceKeyModify-boxBody1"
                />
            </React.Fragment>
        );

        const OTPComponent = (
            <React.Fragment>
                <div className="my-profile-ecommerce-key-info__section-container">
                    <div className="my-profile-ecommerce-key-info__section-container__title">
                        <FormattedText value={`eCommerceKeyModify-titleSectionConfirmation`} />
                    </div> 
                </div>
                <div className="ecommerce-key-modify-view__otp-container">
                    <SignaturePattern
                        operationType={ECOMMERCE_MODIFY_ID}
                        operationParams={{}}
                    />
                </div>
            </React.Fragment>
        );

        const eCommerceModifyKeyContent = (
            <div className="row">
                <div className="col-md-12">
                    <ContentBox>
                        <div className="my-profile-ecommerce-key-info row">
                            <div className="col-xs-12">
                                <ModifyEcommerceKeyStep1
                                    immProfile={immProfile}
                                    immEcommerceKeyModify={immEcommerceKeyModify}
                                    handleConfirmButton={() => this.onHandleConfirmButton}
                                    setEcommerceKey={this.setEcommerceKey}
                                    showConfirmButton={immEcommerceKeyModify.get('showConfirmButton')}
                                    isInputDisabled={immEcommerceKeyModify.get('isInputDisabled')}
                                /> 
                            </div>
                        </div>
                        {immEcommerceKeyModify.get('otpStep') && OTPComponent}
                        <footer className="ecommerce-key-request-view__footer-otp">
                            <div className="ecommerce-key-request-view__cancel-button">
                                <OKLink
                                    modifier="inherit-styles"
                                    to={linkToEcommerceLanding}
                                >
                                    <FormattedText value={`eCommerceKeyModify-cancel`} />
                                </OKLink>
                            </div>
                            <SignaturePatternButton
                                onClick={() => sendNewEcommerceKey(immEcommerceKeyModify.get('challenge'))}
                            >
                                <FormattedText value={`eCommerceKeyModify-modify`} />
                            </SignaturePatternButton>
                        </footer>
                    </ContentBox>
                </div>  
            </div>
         )

        block = (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    {eCommerceModifyKeyContent}
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={formatText('eCommerceKeyModify-boxTitle')}
                                boxBody={boxBody}
                                icon={infoIcon}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
        return block;
    }
        render() {
            const { immEcommerceKeyModify } = this.props;
            let contentModifyView;

            const content = this.buildContent();
            const mappingBreadcrumb = [
                {
                    text: formatText('profileKeysLanding-title'),
                    url: '/myprofile/keys'
                },
                {
                    text: formatText('eCommerceKeyLanding-title'),
                    url: '/myprofile/keys/ecommerce'
                },  
                {
                    text: formatText('eCommerceKeyModify-titleBreadcrumb'),
                    url: ''
                }  
            ];
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

            if (immEcommerceKeyModify.get('error')) {
                contentModifyView = (
                    <div>
                        <div className="container-fluid">
                            <div className="row">
                                <OKCover size="large" section="accounts" customClass="col-xs-12">
                                    <OKHeaderSubPage
                                        titleWrap={true}
                                        breadcrumbConfig={mappingBreadcrumb}
                                        finalTitle={getFinalTitle('eCommerceKeyModify-title')}
                                    />
                                </OKCover>
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    <ErrorStep/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            else if (immEcommerceKeyModify.get('success')) {
                contentModifyView = (
                    <div>
                        <div className="container-fluid">
                            <div className="row">
                                <OKCover size="large" section="accounts" customClass="col-xs-12">
                                    <OKHeaderSubPage
                                        titleWrap={true}
                                        breadcrumbConfig={mappingBreadcrumb}
                                        finalTitle={getFinalTitle('eCommerceKeyModify-title')}
                                    />
                                </OKCover>
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    <SuccessStep/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            else {
                contentModifyView = (
                    <div>
                        <div className="container-fluid">
                            <div className="row">
                                <OKCover size="large" section="accounts" customClass="col-xs-12">
                                    <OKHeaderSubPage
                                        titleWrap={true}
                                        breadcrumbConfig={mappingBreadcrumb}
                                        finalTitle={getFinalTitle('eCommerceKeyModify-title')}
                                    />
                                </OKCover>
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    {content}
                                    <PreLeaveModalComponent
                                        confirmationMessage={confirmationMessage}
                                        confirmationTitle={confirmationTitle}
                                        acceptText={acceptText}
                                        cancelText={cancelText}
                                        isReady={this.isReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

        return contentModifyView 
    }
}


MyProfileEcommerceKeyModifyView.propTypes = {
    immProfile: PropTypes.object,
    immEcommerceKeyModify: PropTypes.object,
    resetModifyEcommerceKey: PropTypes.func, 
    confirmModifyEcommerceKey: PropTypes.func,
    sendNewEcommerceKey: PropTypes.func,
    setEcommerceKeyField: PropTypes.func
};


module.exports.constructor = MyProfileEcommerceKeyModifyView;
module.exports.MyProfileEcommerceKeyModifyView = connect(
    state => ({
        immEcommerceKeyModify: state.ecommerceKeyModify,
        immProfile: state.profile
    }),
    {
        resetModifyEcommerceKey: modifyEcommerceKey.resetModifyEcommerceKey,
        confirmModifyEcommerceKey: modifyEcommerceKey.confirmModifyEcommerceKey,
        sendNewEcommerceKey: modifyEcommerceKey.sendNewEcommerceKey,
        setEcommerceKeyField: modifyEcommerceKey.setEcommerceKeyField
    }
)(MyProfileEcommerceKeyModifyView);